import {
  SupportPlanBillableItemSids,
  SupportPlanBillableItemSidsType,
} from '@twiliointernal/e2-commons-shared-definitions';

/**
 * Returns whether a given billable item sid has Personalized Support.
 * @param billableItemSid - Active plan's billable item sid.
 * @returns boolean
 */
export const isPersonalizedSupport = (
  billableItemSid: SupportPlanBillableItemSidsType,
): boolean => {
  const personalizedSupportPlans: SupportPlanBillableItemSidsType[] = [
    SupportPlanBillableItemSids.personalized,
    SupportPlanBillableItemSids.personalizedPartnerMso,
    SupportPlanBillableItemSids.personalizedPartnerMss,
    SupportPlanBillableItemSids.personalizedPre2018,
    //As of 2024-04-15: Partner Advanced has access to Submit a Ticket, however from an SLA perspective this is still a Business Plan.
    SupportPlanBillableItemSids.partnerAdvanced,
  ];

  return personalizedSupportPlans.includes(billableItemSid);
};
